import React from 'react'
import { Box, Button } from '@mui/material'
import clsx from 'clsx'
import { useNavigate } from 'react-router-dom'
import { useButtonsStyles } from '../../../styles'
import { generateRandomGuiID } from '../../../utils/commonUtils'
import { DataTableActionsProps, HandleClickAction } from './_props'
import sxs from './_styles'

const DataTableActions: React.FC<DataTableActionsProps> = ({ actions = [] }) => {
    const navigate = useNavigate()
    const buttonsClasses = useButtonsStyles()

    const activeActions = actions.filter((action) => [true, undefined].includes(action.display))

    const handleClick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>, action: HandleClickAction) => {
        e.preventDefault()
        e.stopPropagation()

        if (action.onClick) {
            action.onClick()
        }

        if (action.to) {
            navigate(action.to, action?.navigationOptions ?? {})
        }
    }

    return (
        <Box sx={sxs.DataTableActions}>
            {activeActions.map((action) => {
                const id = generateRandomGuiID()
                return (
                    <Button
                        key={id}
                        onClick={(e) => handleClick(e, action)}
                        className={clsx(buttonsClasses.ButtonTextBlack, buttonsClasses.ButtonSmall)}
                        sx={[action?.variant === 'danger' ? sxs.DataTableActionButtonDanger : {}]}
                        size="small"
                        // @ts-expect-error TS(2769) FIXME: No overload matches this call.
                        color="typography"
                        data-cy={action.dataCy}
                        disabled={action.disabled}
                    >
                        {action.icon}
                    </Button>
                )
            })}
        </Box>
    )
}

export default DataTableActions
